import * as React from 'react';
import { TailSpin } from 'react-loader-spinner';

export type SpinnerType = 'default' | 'button';

interface Props {
  /** サブタイプ */
  type?: SpinnerType;
  width?: number;
  height?: number;
  color?: string;
}

export const Spinner: React.FC<Props> = ({
  type = 'default',
  width = 60,
  height = 60,
  color = '#7A8084'
}) => {
  const _clsName = type + 'Spinner';
  return (
    <TailSpin
      color={color}
      height={height}
      width={width}
      wrapperClass={_clsName}
    />
  );
};
